import BackButton from "../ui/BackButton";

export default function MobileStep({ onBack }: { onBack: () => void }) {
  return (
    <div className="space-y-4 animate-slideIn">
      <button className="w-full bg-green-500 text-white py-2 rounded-xl">
        📞 Ooredoo Pay
      </button>
      <button className="w-full bg-yellow-500 text-white py-2 rounded-xl">
        💰 Dhiraagu Pay
      </button>
      <BackButton onClick={onBack} />
    </div>
  );
}